// extracted by mini-css-extract-plugin
export default {"Container":"AddBook_Container__0W7B7","Created":"AddBook_Created__may4B"};